import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { 
  faAward, 
  faSeedling, 
  faHelmetSafety, 
  faBook, 
  faShieldHalved,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons';
import { RouterOutlet } from '@angular/router';
import { CommitmentItem, IsoCertification, CommitmentSection } from '../../../services/models/commitment.model';

@Component({
  selector: 'app-commitment',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet, 
    FaIconComponent
  ],
  templateUrl: './commitment.component.html',
  styleUrls: ['./commitment.component.scss']
})
export class CommitmentComponent implements OnInit {
  // Icons
  protected faQuality: IconDefinition = faAward;
  protected faEnvironment: IconDefinition = faSeedling;
  protected faHealthSafety: IconDefinition = faHelmetSafety;
  protected faCode: IconDefinition = faBook;
  protected faShield: IconDefinition = faShieldHalved;

  // Component Variables
  protected CodeOfConductDocumentUrl: string;
  public env = environment;
  protected selectedCommitment: CommitmentItem | null = null;
  protected selectedIsoContent: string = '';
  protected selectedIsoTitle: string = '';

  // ISO Certification data
  protected isoCertifications: IsoCertification[] = [
    {
      title: 'ISO9001',
      content: 'All Harmony companies worldwide are ISO9001 certified, signifying that we adhere to international standards for a Quality Management System (QMS), ensuring consistent quality of product/service, enhanced customer satisfaction, and a commitment to continuous improvement.',
    },
    {
      title: 'ISO14001',
      content: 'In addition, our ISO14001 and ISO45001 management systems assist member companies in implementing environmental and health & safety standards in their organisations as per these international standards.',
    },
    {
      title: 'ISO45001',
      content: 'In addition, our ISO14001 and ISO45001 management systems assist member companies in implementing environmental and health & safety standards in their organisations as per these international standards.',
    },
    {
      title: 'ISO27001',
      content: 'Our ISO27001 programme is instrumental in maintaining a safe data security and data privacy programme for our head office. We plan to share our experience in this process by helping local member companies establish their own data protection programme.',
    }
  ];

  // Commitment data for the 4 sections
  protected commitmentSections: CommitmentSection[] = [
    {
      title: 'Health & safety',
      content: 'Our employees are of foremost importance to us. They are in daily contact with our customers, and a happy employee will better take care of our customers. The employment conditions which are applied by Harmony can never be adverse to our employees.',
      imagePath: '../../../../assets/icons/color/grey/health-shield.svg'
    },
    {
      title: 'Environment',
      content: 'Harmony is committed to safeguarding the environment. We comply with relevant (international, domestic and local) legislation. In our strategic and operational decision making we take our environmental impact into account to protect the environment from any adverse effects from our activities as much as possible.',
      imagePath: '../../../../assets/icons/color/grey/environment.svg'
    },
    {
      title: 'Ethical business',
      content: 'We value our customers, members, agents, suppliers, and other business partners. We treat these parties the way we want to be treated: fairly and honestly. Ethical business practices are the philosophical core of our business; they are more than values and principles that determine our conduct in our global mobility industry. Our ethical principles apply to our own behaviour, as well as to that of third parties conducting business on our behalf.',
      imagePath: '../../../../assets/icons/color/grey/ethical_business.svg'
    },
    {
      title: 'Privacy protection',
      content: 'The privacy of our customers in this era of information technology is essential and must always be safeguarded. Carrying out global relocations means that we need to collect certain personal data. We do this by following strict rules, in a transparent way, compliant with privacy laws in the countries in which we conduct business.',
      imagePath: '../../../../assets/icons/color/grey/privacy_protection.svg'
    }
  ];

  constructor(private modalService: NgbModal) {
    this.CodeOfConductDocumentUrl = `${this.env.SiteUrls.AzureStorageBaseURL}${this.env.ContainerNames.WebDocuments}/${this.env.Blobs.CodeOfConduct}`;
  }

  ngOnInit() {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  openIsoModal(content: any, isoCert: IsoCertification) {
    this.selectedIsoTitle = isoCert.title;
    this.selectedIsoContent = isoCert.content;
    this.modalService.open(content, { 
      size: 'lg', 
      backdrop: 'static',
      centered: true 
    });
  }

  openCommitmentModal(content: any, commitment: CommitmentSection) {
    this.selectedCommitment = {
      title: commitment.title,
      content: commitment.content,
    };
    this.modalService.open(content, { 
      size: 'lg', 
      backdrop: 'static',
      centered: true 
    });
  }
}
